import React from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {getText, renderMarkdown} from 'helpers/text-helper';
import QR from 'components/ui/qr/qr';
import './game-step-qr.scss';

const GameStepQR = ({languageId, deviceInfo, gameData, gameStepData}) => {

	// const surveyUrl = (appConfig.env === 'development' ? 'http://' : 'https://') + appConfig.gameUrl + '/survey/' + gameData.id;
	return (
		<div className={'GameStepQR ' + deviceInfo.orientation}>
			<div className="GameStepQR-content">
				{gameStepData.title && <div className="GameStepQR-title">
					<span>{getText(gameStepData.title, languageId)}</span>
				</div>}
				{gameStepData.text && <div className="GameStepQR-text">
					{renderMarkdown(getText(gameStepData.text, languageId))}
				</div>}
				<div className='GameStepQR-qr'>
					<QR 
						role="player"
						deviceInfo={deviceInfo} 
						url={'https://' + appConfig.gameUrl + '/survey/' + gameData.id}
					/>
				</div>
				{/* <div className="GameStepQR-url">
					<a href={surveyUrl}>{appConfig.gameUrl + '/survey/' + gameData.id}</a>
				</div> */}
			</div>
		</div>
	);
};

GameStepQR.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameData: PropTypes.object.isRequired,
	gameStepData: PropTypes.object.isRequired
};

export default GameStepQR;